import React from 'react';
import { FOOTER_TITLE_LABEL } from '../../constants/footer';

export default function SAMFooter() {
    const year = new Date().getFullYear();
    return (
        <div className="p-3 text-center">
            <span className="mr-2">&copy;</span>
            <span>{year}</span>
            <span className="mx-2">-</span>
            <span>SAM 1.0</span>
            <br />
            <span>{FOOTER_TITLE_LABEL}</span>
        </div>
    );
}
